var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
        el: '#comments',
        offset: -30,
    }),expression:"{\n        el: '#comments',\n        offset: -30,\n    }"}]},[_c('i',{staticClass:"fad fa-comment-dots contentAction articleActions__commentIcon",staticStyle:{"--fa-primary-color":"white"}}),_vm._v(" "),_vm._t("default",null,{"commentCount":_vm.commentCount})],2)}
var staticRenderFns = []

export { render, staticRenderFns }